module.exports = __webpack_public_path__ + "static/media/home_now.a3acb900.svg";